const phoneNo = /^1[23456789][0-9]{9}$/;
export {phoneNo}